import { ReactElement } from "react";
import { EvaluableType } from "@/services/backend/sample-error/sample-error";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { evaluableTypes } from "../../enum-labels";

interface EvaluableTypeSelectorProps {
  evaluableType: string;
  disabled?: boolean;
  setValue: (value: string) => void;
}

function EvaluableTypeSelector({
  evaluableType,
  setValue,
  disabled = false,
}: EvaluableTypeSelectorProps): ReactElement {
  return (
    <Select
      disabled={disabled}
      value={evaluableType}
      onValueChange={(v) => setValue(v)}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Auswertbarkeit auswählen" />
      </SelectTrigger>
      <SelectContent>
        {Object.values(EvaluableType).map((value) => (
          <SelectItem key={value} value={value}>
            {evaluableTypes[value]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default EvaluableTypeSelector;
